/**
 * 高级设置-消息通知设置
 * @author ariel
 * @date 2020-12-09
 */
import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from '@/tool';
import { WizTableForm } from '@/containers/common'
let { Storage } = utils_tool
const { WizContainer, modelUtils } = framework_tool
import './index.less'

const { WizComponent, WizForm, WizInput, WizIcon, WizButton, WizRow, WizCol, WizCollapse, WizCheckbox, WizTabs, WizRadio, WizSelect } = component_tool
const { TextArea } = WizInput;
const { Option, OptGroup } = WizSelect
const _getValue = (type, key) => {
  const values = {
    sendType: {
      '0': ' 站内通知',
      '1': ' 推送消息',
      '3': ' 短信通知',
      '4': ' 邮件通知',
      '5': ' 企业微信',
      '6': ' 智能电话',
    },
    sendTypeIcon: {
      '0': 'cloud-server',
      '1': 'mobile',
      '3': 'message',
      '4': 'mail',
      '5': 'wechat',
      '6': 'phone',
    },
  }
  return values[type][key] || ''
}

class WizNoticeSet extends WizContainer {

  componentName = "WizNoticeSet";
  constructor(props) {
    super(props);

    let use = Storage.getStorage('user') || {}
    //是否禁用编辑权限
    this.flag = true
    if (use && use.personId === '1cdf270fdc764dfb91634d3b2f48257f') {
      this.flag = false;
    }
    let { record, messageNoticeIds } = props
    let cloneObject = this._cloneProps(record, messageNoticeIds)
    this.state = {
      ...cloneObject,
      labelInfo:props.labelInfo,//app信息
      phoneCodeVisible: false,//是否显示语音通话模板信息
      currentPhoneCode: '',//当前编辑的语音模板编码code
      currentSceneIndex: -1,
      initNow: new Date().getTime(),
      index: -1,
    }
  }

  _cloneProps = (record, messageNoticeIds) => {
    let copyMessageNoticeIds = Object.assign([], messageNoticeIds)
    let copyRecord = []
    if (record && record instanceof Array && record.length > 0) {
      record.forEach(element => {
        let { sceneInfoList, ...other } = element
        let copySceneInfoList = []
        if (sceneInfoList && sceneInfoList instanceof Array && sceneInfoList.length > 0) {
          sceneInfoList.forEach(scenenInfo => {
            copySceneInfoList.push({ ...scenenInfo })
          })
        }
        copyRecord.push(Object.assign({}, { ...other, sceneInfoList: copySceneInfoList }))
      });
    }
    return { record: copyRecord, messageNoticeIds: copyMessageNoticeIds }
  }
  _componentDidMount() {

  }
  propsAndStateOnChange = {
    voiceMsgListByPage: this._voiceMsgListByPage.bind(this)
  };

  //查询语音通话模板信息
  _voiceMsgListByPage(nextProps, nextState) {
    let { voiceMsgListByPage } = nextProps
    if (voiceMsgListByPage && voiceMsgListByPage['success']) {
      nextState['phoneCodeVisible'] = true;
      return true
    } else {
      wizNotice.error(voiceMsgListByPage && voiceMsgListByPage['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props &&
      (nextProps.initNow !=this.props.initNow  || nextProps.messageNoticeIds !=this.props.messageNoticeIds)) {

      let { record, messageNoticeIds, } = this._cloneProps(nextProps.record, nextProps.messageNoticeIds)
      this.setState({ record: record, messageNoticeIds,labelInfo:nextProps.labelInfo })
    }
  }
  _noticeOnChange(commentName, e) {
    if (commentName) {
      this.setState({
        [commentName]: e.target.value
      })
    }
  }
  _appOnChange(commentName, e) {
    if (commentName) {
      this.setState({
        [commentName]: e
      })
    }
  }
  _getNoticeIds(checkedValues, info) {
    let { messageNoticeIds } = this.state
    if (checkedValues instanceof Array) {
      if (checkedValues.length > 0) {
        messageNoticeIds.push(...checkedValues)
      } else {
        messageNoticeIds.splice(messageNoticeIds.findIndex(item => item === info.id), 1)
      }
    }
    //这里需要set一个值，不然state不会检测到发生变化
    this.setState({ messageNoticeIds: messageNoticeIds, messageNoticeIdsJoin: messageNoticeIds.join(",") })
  }

  // _getContentInfo = (asEdit= false,isPhone=false,editFunc =()=>{})=>{
  /**
   * 通知内容
   * @param {通知内容} content
   * @param {选择的应用id} appIds
   * @param {应用选项信息} appLabel
   * @param {是否正在编辑} asEdit
   * @param {是否勾选} disabled
   * @param {通知内容的key} contentKey
   * @param {通知选择应用的key} appIdsKey
   * @param {是否为语音通知} isPhone
   * @param {是否为企业微信推送} isWechat
   * @param {点击编辑时触发的函数} editFunc
   * @param {点击保存时触发的函数} saveFunc
   * @returns
   */
  _getContentInfo = (content = '', appIds = [], appLabel = [], asEdit = false, disabled = false, contentKey = '', isPhone = false, isWechat = false,
    editFunc = () => { }, saveFunc = () => { }, appSaveFunc = () => { }) => {
      
    const appOption = appLabel.map(app =>

      <OptGroup key={'optGroup_notice_'+contentKey } label={app['labelName']}>
        {app.optionList && app.optionList instanceof Array && app.optionList.length > 0 ?
          app.optionList.map(option =>
            <Option  key={'option_notice_'+contentKey+'_'+option.optionValue} value={option.optionValue}>{option.optionName}</Option>)
          : null
        }
      </OptGroup>)
    let colspan = asEdit&&!isPhone ? 21 : 24
    return (
      <WizRow>
        <WizCol span={colspan} style={{ textAlign: 'left' }}>
          {asEdit && !isPhone ?
            <TextArea ref={contentKey} key={contentKey}
              value={this.state[contentKey]}
              maxLength={500} rows={4}
              placeholder="请输入通知内容"
              onChange={this._noticeOnChange.bind(this, contentKey)} />
            :
            <div>
              {isWechat ?
                <div className="apply-notice-value" >
                  <div className="apply-notice-value__app">选择应用：</div>
                  <WizSelect style={{ width: '100%', "minWidth": '72px', "paddingRight": '7px' }}
                    placeholder="请选择应用"

                    required={true}
                    allowClear={true}
                    disabled={disabled}
                    defaultValue={appIds}
                    initialValue={appIds}
                    mode="multiple"
                    onChange={appSaveFunc.bind(this)}
                  >
                    {appOption}
                  </WizSelect>
                </div>
                : <></>}
              <div className="apply-notice-value" >
                <div className="apply-notice-value__title">通知内容：</div>
                {content != '' && content !== undefined ?
                  <div className="apply-notice-value__value" onClick={editFunc}>
                    <p>{content}</p>
                  </div>
                  : <div className="apply-notice-value__title">暂无</div>
                }
              </div>
            </div>
          }
        </WizCol>
        {asEdit&&!isPhone ?
          <WizCol span={3} style={{ textAlign: 'right' }}>
            <WizButton type="primary" onClick={saveFunc}>保存</WizButton>
          </WizCol>
          : <></>
        }
      </WizRow>
    )
  }
  /**
   * 构建通知方式
   * @param {数据库中的通知方式内容} list
   * @param {当前通知模式的index} currentSceneIndex
   * @param {应用选项} appLabel
   * @returns
   */
  _getContentList = (list = [], currentSceneIndex = 0, appLabel = []) => {
    //已勾选的通知id
    const { appCheck, record, messageNoticeIds, initNow } = this.state
    let activeKeys = []
    list.forEach((info) => {
      activeKeys.push(info.sendType)
    })
    let defaultActiveKey = list.filter(item => item.state == 1).map(item => item.sendType)
    let r = []
    list.forEach((info, index) => {
      //判断是否为语音通知
      let isPhone = info['sendType'] === 6
      let isWechat = info['sendType'] === 5

      let contentKey = currentSceneIndex + '@comment@' + index
      let appIdsKey = currentSceneIndex + '@appIds@' + index
      let saveFuc = () => {
        //保存record的值
        let comment = this.state[currentSceneIndex + '@comment@' + index]
        let code = this.state[currentSceneIndex + '@code@' + index]
        let appIds = this.state[currentSceneIndex + '@appIds@' + index]
        record[currentSceneIndex]['sceneInfoList'][index]['content'] = comment
        record[currentSceneIndex]['sceneInfoList'][index]['code'] = code
        record[currentSceneIndex]['sceneInfoList'][index]['appIds'] = appIds
        this.setState({
          [currentSceneIndex + '@Group@' + index]: 0,
        }, () => {
        })
      }
      // 判断通知方式是否勾选到
      let disabled = !messageNoticeIds.includes(info.id)

      let editFuc = disabled&&this.flag ? null : () => {
        this.setState({
          [currentSceneIndex + '@Group@' + index]: 1,
          [currentSceneIndex + '@comment@' + index]: info['content'],
          [currentSceneIndex + '@code@' + index]: info['code'],
          [currentSceneIndex + '@appIds@' + index]: info['appIds'],
          currentPhoneCode: info['code'],
          currentSceneIndex: currentSceneIndex,
          index: index,
          phoneCodeVisible: isPhone ? true : false
        }, () => {
        })
      }

      let appSaveFunc = (appIds) => {

        //保存record的值
        record[currentSceneIndex]['sceneInfoList'][index]['appIds'] = appIds
        this.setState({
          [currentSceneIndex + '@appIds@' + index]: appIds
        }, () => {
        })
      }
      r.push(
        <WizCollapse key ={currentSceneIndex+'@'+info.sendType} defaultActiveKey={defaultActiveKey} className='noticeSet collapse_content' >
          <WizCollapse.Panel
            key={info.sendType}
            header={
              <WizRow>
                <WizCol>
                  <WizCheckbox.Group
                    key={info.sendType}
                    options={[
                      {
                        label: <>
                          <WizIcon type={_getValue('sendTypeIcon', info.sendType)} />
                          {_getValue('sendType', info.sendType)}
                        </>,
                        value: info.id
                      }
                    ]}
                    defaultValue={messageNoticeIds}
                    onChange={(checkedValues) => this._getNoticeIds(checkedValues, info)}
                    onClick={(e) => { e.stopPropagation() }}
                  />
                </WizCol>
              </WizRow>
            }
          >
            {this._getContentInfo(info['content'], info['appIds'], appLabel,
              info.sendType === 3 ? false: this.state[currentSceneIndex + '@Group@' + index], disabled, contentKey,
              isPhone, isWechat,
              editFuc, saveFuc, appSaveFunc)}

          </WizCollapse.Panel>
        </WizCollapse>
      )
    })
    return (
      <WizRow>
        <WizCol span={5}>通知方式:</WizCol>
        <WizCol span={18}>
          {r}
        </WizCol>
      </WizRow>

    )
  }

  _getNoticeInfo = () => {
    let { record = [], initNow, labelInfo } = this.state
    let recordInfo = [...record]
    let appLabel = labelInfo || []

    recordInfo.forEach((e) => {
      let info = [];
      if (e.sceneInfoList && e.sceneInfoList.length) {
        e.sceneInfoList.forEach((v) => {
          info.push(v.id)
        })
        e.sceneId = Math.min(...info)
      }
    })

    let contentList = []
    recordInfo && recordInfo.length && recordInfo.forEach((data, index) => {
      contentList.push(
        <WizTabs.TabPane tab={data.sceneName} key={initNow + '_' + data.sceneId}>
          {this._getContentList(data.sceneInfoList, index, appLabel)}
          <WizRow>
            <WizCol span={5}>是否通知白名单:</WizCol>
            <WizCol span={18}>
              <WizRadio.Group
                key={data.noticeWhitelist}
                options={[{ label: '是', value: 1 }, { label: '否', value: 0 }]}
                defaultValue={data.noticeWhitelist}
                onChange={(e) => {
                  let noticeWhitelist = e.target.value
                  record[index]['noticeWhitelist'] = noticeWhitelist
                  this.setState(record)
                }
                }
              />
            </WizCol>
          </WizRow>
        </WizTabs.TabPane>
      )
    })
    contentList = contentList.sort((a, b) => { return a.key - b.key });
    return (
      <WizTabs onChange={this.changeTab}>
        {contentList}
      </WizTabs>
    )
  }

  _onNoticeSubmit(values) {
    let { submit } = this.props;
    let { record, messageNoticeIds } = this.state
    let errorMsg = ''
    let templateList = []
    if (record && record instanceof Array && record.length > 0) {
      record?.forEach(element => {
        element?.sceneInfoList?.forEach(sceneInfo => {
          let infoState = messageNoticeIds.includes(sceneInfo.id) ? 1 : 0
          if(infoState && sceneInfo.sendType==5 && !sceneInfo?.appIds?.length){
            errorMsg=element?.sceneName+'【企业微信通知】已选择,应用不能为空'
          }
          if(infoState){
          let template = {
            noticeWhitelist: element?.noticeWhitelist, state: infoState,
            content: sceneInfo.content, sendType: sceneInfo.sendType, id: sceneInfo.id, appIds: sceneInfo.appIds
          }
          if (sceneInfo.code != null && sceneInfo != undefined) {
            template = { ...template, code: sceneInfo.code }
          }
          templateList.push({ ...template })
        }
        })
      });
      values['templateList'] = templateList
    }
    if(errorMsg){
      wizNotice.error(errorMsg)
      return false
    }

    if (values['noticeState'] === 1) {
      values['messageNoticeIds'] = this.state.messageNoticeIds
    }
   submit(values)
  }

  //弹出框取消按钮事件
  _tableCancel = (obj, e) => {
    this.setState({
      phoneCodeVisible: false,
    });
  }
  _renderBtn = (value, valueRows) => {
    return (
      <></>
    )
  }
  _tableSubmit = (obj, e) => {
    let { currentSceneIndex, record, index } = this.state
    if (obj['value'] && obj['valueRows'] instanceof Array && obj['valueRows'].length > 0) {
      if (record?.[currentSceneIndex]?.['sceneInfoList']?.[index]) {
        record[currentSceneIndex]['sceneInfoList'][index]['code'] = obj['valueRows'][0]['code']
        record[currentSceneIndex]['sceneInfoList'][index]['content'] = obj['valueRows'][0]['content']
        record[currentSceneIndex]['sceneInfoList'][index]['appIds'] = obj['valueRows'][0]['appIds']
      }
    }
    this.setState({
      phoneCodeVisible: false
    });
  }

  _render() {
    let { record, phoneCodeVisible, currentPhoneCode } = this.state
    let noticeState = 0;
    if (record && record.length && record.length > 0) {
      record.forEach((e) => {
        e.sceneInfoList && e.sceneInfoList.length && e.sceneInfoList.forEach((value) => {
          if (value.state === 1) {
            noticeState = 1
          }
        })
      })
    }


    let columns = []
    columns = columns.concat([
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: record && record.id
        }
      },
      {
        title: '消息通知',
        name: 'noticeState',
        formItem: {
          type: 'radio',
          initialValue: noticeState
        },
        dict: [
          { code: 1, codeName: '是' },
          { code: 0, codeName: '否' }
        ]
      },
      {
        title: '通知模式',
        name: 'notice',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            return (
              <>
                {this._getNoticeInfo()}
              </>
            )
          }
        }
      }
    ])

    let onNoticeSubmit = this._onNoticeSubmit.bind(this)

    let formProps = {
      ref: 'form',
      columns: columns,
      onSubmit: onNoticeSubmit,
      onReset: (f) => {
        let cloneObject = this._cloneProps(this.props.record, this.props.messageNoticeIds)

        this.setState({
          ...cloneObject,
          phoneCodeVisible: false,//是否显示语音通话模板信息
          currentPhoneCode: '',//当前编辑的语音模板编码code
          currentSceneIndex: -1,
          initNow: new Date().getTime(),
          index: -1,
        })
      },
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }
    const voiceMsgConfig = WizTableForm.Config.voiceMsg(this, { apiParams: {} })
    let initialValue = [currentPhoneCode]

    let initRows = [{ code: currentPhoneCode }]
    return (
      <div className='noticeSet'>
        <WizForm {...formProps} />
        <WizTableForm key={currentPhoneCode} {...voiceMsgConfig} showModal={true} visible={phoneCodeVisible}
          selectType={'radio'} value={initialValue} initRows={initRows}
          onSubmit={this._tableSubmit}
          renderValue={this._renderBtn}
          onCancel={this._tableCancel}
        />
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {

  const { noticeTemplate, thirdApp } = state;
  const voiceMsgListByPage = modelUtils.getModelEntity(noticeTemplate, "voiceMsgListByPage");

  //const labelInfo = modelUtils.getModelEntity(thirdApp, "thirdApp@labelInfo");
  const load = modelUtils.getLoadingState(state, ['noticeTemplate', 'thirdApp']);
  return {
    voiceMsgListByPage,
    //labelInfo,
    ...load
  }
};

export default connect(mapStateToProps)(WizNoticeSet);

